import creative from 'views/challenge/types/creative';
import KPI from 'views/challenge/types/KPI';
import target from 'views/challenge/types/target';

export default {
	...creative,
	...KPI,
	...target,
};
